/**
 * 处理 UserId 的中间件
 * 在每一接口请求体注入当前登录用户的UserId
 */
import { TafMiddleware } from "../helper";
import { getUserId } from "@/api/_tafFetch";
import { shouldInjectUserId } from "./userId-exclusion";

export const userIdMiddleware: TafMiddleware = async (ctx, next) => {
  const reqInstance =
    typeof ctx.request.ReqClass === "function" ? new ctx.request.ReqClass() : null;
  if (reqInstance) {
    const keys = ["tId", "tUserId", "userId"];
    const hasUserIdKeys = keys.filter(key => reqInstance?.[key]);
    if (
      hasUserIdKeys.length &&
      shouldInjectUserId(ctx.request.moduleName, ctx.request.funcName)
    ) {
      const userId = await getUserId();
      hasUserIdKeys.forEach(key => {
        if (!ctx.request.data) ctx.request.data = {};
        ctx.request.data[key] = userId;
      });
    }
  }
  await next();
};
